<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{
              `${this.$t("expense.edit.title")}`
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("expense.edit.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="expense.title"
                    name="title"
                    label="Title"
                    rows="2"
                    v-validate="'required'"
                    :error="
                      errors.first('title') != null ||
                      serverSideErrors.title != null
                    "
                    :error-messages="
                      errors.first('title') || serverSideErrors.title
                    "
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="expense.note"
                    name="note"
                    label="Note"
                    v-validate="'required'"
                    rows="2"
                    :error="
                      errors.first('note') != null ||
                      serverSideErrors.note != null
                    "
                    :error-messages="
                      errors.first('note') || serverSideErrors.note
                    "
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="expense.amount"
                    name="amount"
                    label="Amount"
                    v-validate="'required|decimal|max_value:9999999'"
                    rows="2"
                    :error="
                      errors.first('amount') != null ||
                      serverSideErrors.amount != null
                    "
                    :error-messages="
                      errors.first('amount') || serverSideErrors.amount
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="10" xs="10" sm="10" md="5">
                  <v-select
                    v-model="expense.category_id"
                    label="Category"
                    name="category"
                    :items="categories"
                    item-text="name"
                    item-value="id"
                    dense
                    v-validate="'required'"
                    :error="
                      errors.first('category') != null ||
                      serverSideErrors.category_id != null
                    "
                    :error-messages="
                      errors.first('category') || serverSideErrors.category_id
                    "
                  />
                </v-col>
                <v-col cols="2" xs="2" sm="2" md="2">
                  <v-btn class="primary" @click="addCategoryDialog = true">
                    <v-icon> mdi-plus </v-icon>
            </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-datetime-picker
                    label="Date"
                    id="Date"
                    name="date"
                    data-vv-as="Date"
                    clearable
                    dateFormat="dd-MM-yyyy"
                    timeFormat="hh:mm a"
                    v-model="expense.date"
                    v-validate="'required'"
                    :error="
                      errors.first('date') != null ||
                      serverSideErrors.date != null
                    "
                    :error-messages="
                      errors.first('date') || serverSideErrors.date
                    "
                  >
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-clock-outline</v-icon>
                    </template>
                  </v-datetime-picker>
                  <span
                    class="red--text"
                    v-if="errors.first('date') || serverSideErrors.date"
                  >
                    {{ errors.first("date") || serverSideErrors.date }}
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-file-input
                    v-model="expense.documents"
                    dense
                    label="Expense Document"
                    prepend-icon="mdi-camera"
                    multiple
                    :error="serverSideErrors.documents != null"
                    :error-messages="serverSideErrors.documents"
                    hint="Only pdf, jpg, png, gif, jpeg file types are allowed"
                    persistent-hint
                    ><template v-slot:selection="{ text }">
                      <v-chip small label color="primary">
                        {{ text }}
                      </v-chip>
                    </template></v-file-input
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  v-for="item in added_documents"
                  :key="item.document_url"
                  class="d-flex child-flex"
                  cols="2"
                >
                  <v-card>
                    <v-img
                      v-if="item.file_type == 'image'"
                      :src="API_BASE_URL + '/uploads/' + item.document_url"
                      :lazy-src="API_BASE_URL + '/uploads/' + item.document_url"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      :src="API_BASE_URL + '/default-pdf.png'"
                      :lazy-src="API_BASE_URL + '/default-pdf.png'"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-btn
                      icon
                      color="secondary"
                      name="delete_expense"
                      title="Edit Expense"
                      @click="confirmDelete(item.id)"
                    >
                      <v-icon small> mdi-close </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="secondary"
                      name="view_expense"
                      title="Edit "
                      @click="imgClick(item)"
                      style="float: right"
                    >
                      <v-icon small v-if="item.file_type == 'image'">
                        mdi-eye</v-icon
                      >
                      <v-icon small v-else> mdi-eye</v-icon>
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="saveExpenseDetail"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-dialog v-model="imageDialog" max-width="100vh">
        <v-card>
          <v-btn
            icon
            color="secondary"
            name="delete_notice"
            title="Edit Notice"
            @click="imageDialog = false"
            style="float: right"
          >
            <v-icon small> mdi-close </v-icon>
          </v-btn>
          <v-card-title class="text-h5 grey lighten-2">
            <v-img
              :src="API_BASE_URL + '/uploads/' + image_url"
              :lazy-src="API_BASE_URL + '/uploads/' + image_url"
              aspect-ratio="1"
              class="grey lighten-2"
            ></v-img>
          </v-card-title>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteDocument(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <AddCategoryDialog :dialog.sync="addCategoryDialog" :categories="categories" @category-added="handleCategoryAdded" @alert="handleAlert" />
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import moment from "moment";
import AddCategoryDialog from '@/components/societyadmin/expense/AddCategory.vue';

export default {
  components: {
    AddCategoryDialog,
  },
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      expense: {
        title: "",
        description: "",
        documents: [],
        category_id: null
      },
      added_documents: [],
      delete_id: "",
      deleteDialog: false,
      imageDialog: false,
      image_url: "",
      base_url: process.env.VUE_APP_API_URL,
      categories: [],
      addCategoryDialog: false
    };
  },

  methods: {
    ...mapMutations("alert", ["setAlert"]),
    removeAllFiles() {
      this.$refs.dropzone.removeAllFiles();
    },
    handleAlert(alertData) {
      this.setAlert(alertData);
    },
    handleCategoryAdded() {
      this.getCategories(); // Update the categories list
    },
    saveExpenseDetail() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          formData.append("title", this.expense.title);
          formData.append("note", this.expense.note);
          formData.append("date", moment.utc(this.expense.date).valueOf());
          formData.append("amount", this.expense.amount);
          formData.append("category_id",this.expense.category_id ? this.expense.category_id : null);
          for (let i = 0; i < this.expense.documents.length; i++) {
            formData.append("documents[]", this.expense.documents[i]);
          }

          _self.$axios
            .put("/societyadmin/expenses/" + this.expense.id, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });

                _self.$router.push({ path: "/societyadmin/expense" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
    getExpenseDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/expenses/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;
          if (data.status) {
            _self.expense = data.expense;
            let formatDoc = this.expense.documents.map((x) => {
              x.name = x.document_url.replace("expense_documents/", "");
            });
            data.expense.date = new Date(data.expense.date);
            _self.expense = data.expense;
            console.log("formatDoc", formatDoc);
            _self.added_documents = data.expense.documents;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    deleteDocument(Id) {
      let _self = this;
      _self.$axios
        .delete("societyadmin/expenses/documents/" + Id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            console.log(data.status);
            this.getExpenseDetail();
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    closeDialog() {
      (this.deleteDialog = false), (this.delete_id = "");
    },
    imgClick(item) {
      // if (item.file_type == "image") {
      //   this.image_url = item.document_url;
      //   this.imageDialog = true;
      // } else {
      window.open(`${this.base_url}/uploads/${item.document_url}`, "_blank");
      // }
    },
    getCategories() {
      let _self = this;

      _self.$axios.get("societyadmin/categories?recordsPerPage=99999999").then((response) => {
        let data = response.data;

        if (data.status) {
          _self.categories = data.categories;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getExpenseDetail();
    this.getCategories();
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
</style>